import type { SelectableListMenuDataWithMetadata } from '@/features/tocMenu/tocMenuSlice'
import type { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import type { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'
import { filterArchivedActivities } from './filterArchivedActivities'

export const mapActivityPartToSelectableListMenuData = (
  activityPart: FrontActivityPart<FrontActivityWithAggregate>,
): SelectableListMenuDataWithMetadata => {
  return {
    id: activityPart.axis as string,
    name: activityPart?.childActivity?.name,
    children: (activityPart?.childActivity?.children || [])
      .filter((item) => filterArchivedActivities(item))
      .map((item) => mapActivityPartToSelectableListMenuData(item)),
    metadata: {
      activityPart,
    },
  }
}
